<section class="disclaimer">
  <h3>{{ title }}</h3>
  <p>{{ disclaimerText }}</p>
  <ng-container *ngIf="disclaimerLink">
    <a [href]="disclaimerLink" target="_blank">{{ linkText }}</a>
  </ng-container>
</section>
